export default {"src":"/_next/static/media/amoozesh-parvaresh.e1467eb3.svg","height":37,"width":131,"blurWidth":0,"blurHeight":0};